export default function getYear(){
    const fecha= new Date;
    return fecha.getFullYear(); 
}